import { axiosInstance } from "../config";

export default {
  state: {
    cameras: {},
  },
  mutations: {
    SetCameras(state, payload) {
      state.cameras = payload;
    },
  },
  actions: {
    async Get_Cameras({ commit }, payload) {
      if (!payload) {
        payload = "";
      } else {
        payload = "/" + payload;
      }
      return await axiosInstance
        .get(`/cameras${payload}`, {
          headers: {
            Authorization: `Bearer ${
              window.localStorage.getItem("userToken") ??
              window.localStorage.getItem("token")
            }`,
          },
        })
        .then(function (data) {
          commit("SetCameras", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Post_Cameras(commit, payload) {
      return await axiosInstance
        .post("/cameras", payload)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Put_Cameras(commit, payload) {
      const formData = new FormData();
      formData.append("_method", "PUT");
      for (const key in payload) {
        if (
          Object.prototype.hasOwnProperty.call(payload, key) &&
          payload[key] !== undefined
        ) {
          formData.append(key, payload[key]);
        }
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/cameras/" + payload.id, formData, config)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Delete_Cameras(commit, payload) {
      return await axiosInstance
        .delete("/cameras/" + payload.id)
        .then(function (data) {
          return data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
  },
  getters: {
    g_cameras: (state) => state.cameras,
  },
};
